import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PageLayout from 'layouts/PageLayout'
import { Error } from 'components'

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/crypto-pay/order-details'
        render={(routeProps) => require('./OrderDetails').default(routeProps)}
      />
      <Route
        path='/crypto-pay/result'
        render={(routeProps) => require('./Result').default(routeProps)}
      />
      <Route path='*'>
        <PageLayout>
          <Error type='404' />
        </PageLayout>
      </Route>
    </Switch>
  )
}

export default AppRouter
